module.exports = __webpack_public_path__ + "media/buy-now/sample_box8-1d7cbcc8.png";